import React from 'react';
import {
  Speed as SpeedIcon,
  Memory as MemoryIcon,
  Info as InfoIcon,
  Storage as StorageIcon
} from '@mui/icons-material';

export const DEFAULT_SETTINGS = {
  loggingEnabled: true,
  duplicateToCloudLogs: true,
  maxBatchSizeBytes: 512 * 1024, // 512KB
  maxBatchCount: 50,
  flushIntervalMilliseconds: 5000, // 5 seconds
  maxMemoryMegabytes: 30,
  minimumLogLevel: 'info'
};

export const PRESETS = {
  highPerformance: {
    name: 'High Performance',
    description: 'Optimized for high-volume processing with minimal overhead',
    icon: <SpeedIcon />,
    settings: {
      loggingEnabled: true,
      duplicateToCloudLogs: false,
      maxBatchSizeBytes: 256 * 1024,
      maxBatchCount: 25,
      flushIntervalMilliseconds: 2000,
      maxMemoryMegabytes: 20,
      minimumLogLevel: 'warn'
    }
  },
  realTime: {
    name: 'Real-Time Visibility',
    description: 'Maximum visibility with frequent updates',
    icon: <StorageIcon />,
    settings: {
      loggingEnabled: true,
      duplicateToCloudLogs: true,
      maxBatchSizeBytes: 128 * 1024,
      maxBatchCount: 10,
      flushIntervalMilliseconds: 1000,
      maxMemoryMegabytes: 10,
      minimumLogLevel: 'info'
    }
  },
  debug: {
    name: 'Debug Mode',
    description: 'Detailed logging for troubleshooting',
    icon: <InfoIcon />,
    settings: {
      loggingEnabled: true,
      duplicateToCloudLogs: true,
      maxBatchSizeBytes: 64 * 1024,
      maxBatchCount: 5,
      flushIntervalMilliseconds: 500,
      maxMemoryMegabytes: 5,
      minimumLogLevel: 'debug'
    }
  },
  lowMemory: {
    name: 'Low Memory',
    description: 'Minimal memory usage for resource-constrained environments',
    icon: <MemoryIcon />,
    settings: {
      loggingEnabled: true,
      duplicateToCloudLogs: false,
      maxBatchSizeBytes: 128 * 1024,
      maxBatchCount: 10,
      flushIntervalMilliseconds: 1000,
      maxMemoryMegabytes: 10,
      minimumLogLevel: 'error'
    }
  }
};
